/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createSquare } from '../../factoriesAny.js';
export var squareDependencies = {
  typedDependencies,
  createSquare
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesSquare.generated.js
// module id = 1481
// module chunks = 2